import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Sidebar from "../../SideComponents/BlogsSidebar";
import Styles from "../../../assets/css/Blogs/ProblemSolving/MobileResponsiveness.module.css";
import debounce from "lodash.debounce"; // lodash.debounce , It will Add delay to observer that can help stoping the flickerings
import { Helmet } from "react-helmet-async";

// Global States imports
import { useGlobalState } from "../../../Functions/GlobalStates";

const MobileResponsiveness = () => {
  // This Id Will Help Get Likes & Views Of This Problem⬇️
  const questionId = "4"; // Replace with dynamic question ID
  const [likes, setLikes] = useState(0); // State to hold the number of likes
  const [Views, setViews] = useState(0); // State to hold the number of likes
  // Global States
  const { PagesWidthHeight, setPagesWidthHeight } = useGlobalState();
  // React useRef Refferences
  const CheckMobileResponsivenessSize = useRef(false);

  // Fetching images
  // const MobileResponsivenessSolutionImages = require.context(
  //   "../../../assets/images/Blogs/MobileResponsiveness", // Path to the directory
  //   false, // Do not include subdirectories (set to true if you want to include them)
  //   /\.(png|PNG|jpg|jpeg|webp|svg)$/ // Regular expression to match file types
  // );
  // const SolutionImages = [
  // MobileResponsivenessSolutionImages("./screen1.png"), // Dynamically load the image
  // MobileResponsivenessSolutionImages("./screen2.png"), // Dynamically load the image
  // MobileResponsivenessSolutionImages("./screen3.png"), // Dynamically load the image
  // MobileResponsivenessSolutionImages("./screen4.png"), // Dynamically load the image
  // MobileResponsivenessSolutionImages("./screen5.png"), // Dynamically load the image
  // ];

  // updating height to modify sidebar height
  useEffect(() => {
    const updateSize = () => {
      const { height } =
        CheckMobileResponsivenessSize.current.getBoundingClientRect();
      setPagesWidthHeight((prev) => ({
        ...prev,
        height: parseFloat(height.toFixed(1)),
      }));
      // console.log("Heigth", height);
    };

    updateSize(); // Run once on mount
    // Debounce Will Help Derease the Consuption of the Ram & Limit Bulk re-Runing Funtions in a Sec
    const updateSizeDelay = debounce(updateSize, 100);
    window.addEventListener("resize", updateSize);
    window.addEventListener("scroll", updateSizeDelay);

    // Cleanup function to remove event listener when component unmounts
    return () => {
      window.removeEventListener("resize", updateSize);
      window.removeEventListener("scroll", updateSizeDelay);
    };
  }, []);

  // Fetch Likes From Database
  useEffect(() => {
    const AllViews = async () => {
      const hasViewed = localStorage.getItem(`viewed_${questionId}`); // Check if user has already viewed this question

      try {
        if (hasViewed) {
          // alert("You have already Viewed this question.");
          // Fetching the current view data
          const ViewsResponse = await axios.get(
            `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
          );
          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            // alert('Thank you for Viewing the question!');
          } else {
            console.error("No view data received from the get req and server");
          }
        } else {
          // Sending PUT request to the server to update or create the view count
          const ViewsResponse = await axios.put(
            `https://affiliators.netlify.app/.netlify/functions/server/api/views/${questionId}`
          );

          if (ViewsResponse.data && ViewsResponse.data.views !== undefined) {
            setViews(ViewsResponse.data.views); // Update the state with the number of views
            localStorage.setItem(`viewed_${questionId}`, "true"); // Mark as viewed in localStorage
            // alert("Thank you for Viewing the question!");
          } else {
            console.error("No view data received from the put req and server");
          }
        }
      } catch (error) {
        console.error("Error updating views:", error.message);

        // Check if the error is due to the document not being found
        if (error.response && error.response.status === 404 && !hasViewed) {
          // Retry by invoking GET request to create the data if missing
          try {
            // Retry the GET request only if the user has not viewed yet
            const retryResponse = await axios.get(
              `https://affiliators.netlify.app/.netlify/functions/server/api/getviews/${questionId}`
            );
            if (retryResponse.data && retryResponse.data.views !== undefined) {
              setViews(retryResponse.data.views); // Update state with the number of views
              // alert("Thank you for Viewing the question!");
            } else {
              console.error("No view data received from the retry GET request");
            }
          } catch (retryError) {
            console.error("Error on retrying GET request:", retryError.message);
            // alert("Error retrying to fetch view data. Please try again later.");
          }
        } else {
          // alert("Error updating views. Please try again later.");
        }
      }
    };

    AllViews();

    const fetchOrAddLikes = async () => {
      try {
        const fetchresponse = await axios.get(
          `https://affiliators.netlify.app/.netlify/functions/server/api/checklikes/${questionId}`
        ); // Fetch or create likes
        setLikes(fetchresponse.data.likes); // Update state with the number of likes
      } catch (error) {
        console.error("Error fetching or adding likes:", error.message);
      }
    };

    fetchOrAddLikes();
  }, []);

  const HandleLike = async () => {
    const hasLiked = localStorage.getItem(`liked_${questionId}`); // Check if user has liked the question

    if (hasLiked) {
      // alert("You have already liked this question.");
      return;
    }
    try {
      const response = await axios.put(
        `https://affiliators.netlify.app/.netlify/functions/server/api/updatelikes/${questionId}`
      ); // Send request to backend
      setLikes(response.data.likes); // Update the likes state with the latest count

      // Store in localStorage to prevent multiple likes
      localStorage.setItem(`liked_${questionId}`, "true");
      // alert("Thank you for liking the question!");
    } catch (error) {
      console.error("Error updating likes:", error.message);
    }
  };

  const SidebarProps = {
    RTL1: "https://www.hotjar.com/website-problems/mobile/",
    RTL2: "https://www.browserstack.com/guide/why-website-loading-slow",
    RTL3: "https://www.carlcare.com/ng/tips-detail/unresponsive-touch-screen/",
    RTL4: "https://zappit.ai/blog/viewport-not-configured-shopware",
    RTL5: "https://stackoverflow.com/questions/15858511/why-font-size-does-not-change",
    RTL6: "https://stackoverflow.com/questions/3305834/css-overflow-problems",
    RTC1: "Unresponsive Design",
    RTC2: "Slow Loading Speed",
    RTC3: "Touchscreen Issues",
    RTC4: "Viewport Misconfiguration",
    RTC5: "Font Size Problems",
    RTC6: "Content Overflow",
  };

  return (
    <>
      <Helmet>
        {/* Page Title */}
        <title>No More Poor Mobile Responsiveness 📱</title>

        {/* Meta Description */}
        <meta
          name="description"
          content="Learn how poor mobile responsiveness can hurt user experience and discover tips to improve site performance on mobile devices."
        />

        {/* Keywords for SEO */}
        <meta
          name="keywords"
          content="mobile responsiveness, user experience, mobile-friendly design, responsive web design, site performance"
        />

        {/* Responsive Design */}
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph Meta Tags for Social Sharing */}
        <meta
          property="og:title"
          content="No More Poor Mobile Responsiveness 📱"
        />
        <meta
          property="og:description"
          content="Learn how poor mobile responsiveness can hurt user experience and discover tips to improve site performance on mobile devices."
        />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://affiliators.netlify.app/#/problemsolving/mobileresponsiveness"
        />
        {/* <meta
          property="og:image"
          content="/images/MobileResponsiveness/mobileresponsiveness1.png"
        /> */}

        {/* Twitter Meta Tags for Social Sharing */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="No More Poor Mobile Responsiveness 📱"
        />
        <meta
          name="twitter:description"
          content="Learn how poor mobile responsiveness can hurt user experience and discover tips to improve site performance on mobile devices."
        />
        {/* <meta
          name="twitter:image"
          content="/images/MobileResponsiveness/mobileresponsiveness1.png"
        /> */}

        {/* Robots Meta Tag */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        {/* <link
          rel="canonical"
          href="https://affiliators.netlify.app/#/problemsolving/mobileresponsiveness"
        /> */}

        {/* Additional Meta Tags */}
        <meta name="author" content="Zeeshan Ahmad Kamran" />
        <meta name="language" content="en" />
        <meta http-equiv="Content-Language" content="en" />
      </Helmet>
      <div className={Styles.BlogSidebarMobileResponsivenessContainer}>
        <Sidebar {...SidebarProps} />
        <div
          ref={CheckMobileResponsivenessSize}
          className={Styles.MobileResponsivenessContainer}
        >
          <section className={Styles.MobileResponsivenessSection1Container}>
            <div
              className={
                Styles.MobileResponsivenessSection1QuestionLikesViewsContainer
              }
            >
              <h4>Problem</h4>
              <h1>Poor Mobile Responsiveness Hurts User Experience.</h1>
              <div
                className={
                  Styles.MobileResponsivenessSection1LikesViewsContainer
                }
              >
                <button
                  className={Styles.LikeButton}
                  onClick={HandleLike}
                  aria-label="Like this question"
                >
                  👍🏻 {likes}
                </button>
                <span>{Views} Views</span>
              </div>
            </div>
          </section>
          <section className={Styles.MobileResponsivenessSection2Container}>
            <div className={Styles.MobileResponsivenessSection2AnswerContainer}>
              <h4>Solution</h4>
              <p>Follow These Steps:</p>
              <h3>Step No. 1 ....</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.MobileResponsivenessSection2AnswerVideo1}
                src="https://www.youtube.com/embed/K24lUqcT0Ms?si=OwkFVD-08Qegj_ih"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <p>
                If the following video solved your problem, feel free to skip
                the remaining steps. If not, continue with the next steps ⬇️
              </p>
              <h3>Step 2: Use a Responsive Design</h3>
              {/* <h3>For Windows Users</h3> */}
              <div
                className={
                  Styles.MobileResponsivenessSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Choose a mobile-friendly theme that adapts to different
                    screen sizes.
                  </p>
                  {/* <img src={SolutionImages[0]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Implement fluid grids to ensure elements resize
                    proportionally.
                  </p>
                  {/* <img src={SolutionImages[2]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Use flexible images and media that adjust based on the
                    screen resolution.
                  </p>
                  {/* <img src={SolutionImages[1]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 3: Optimize Page Load Speed</h3>
              <div
                className={
                  Styles.MobileResponsivenessSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Compress images using tools like TinyPNG or WebP formats.
                  </p>

                  <p>
                    👉🏻 Enable browser caching to reduce load times for returning
                    visitors.
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Minimize CSS, JavaScript, and unnecessary plugins.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 4: Ensure Touch-Friendly Navigation</h3>
              <div
                className={
                  Styles.MobileResponsivenessSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Use large, tappable buttons for easy interaction.</p>

                  <p>
                    👉🏻 Avoid hover-based menus that don’t work well on
                    touchscreens.
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Keep navigation simple with a mobile-friendly menu.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 5: Implement Mobile-Friendly Fonts & Readability</h3>
              <p>Watch this video:</p>
              <iframe
                className={Styles.MobileResponsivenessSection2AnswerVideo1}
                src="https://www.youtube.com/embed/QhhYZJFOZnY?si=clkHxgf-zsU6aenV"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
              <div
                className={
                  Styles.MobileResponsivenessSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Choose legible font sizes (at least 16px for body text).
                  </p>

                  <p>👉🏻 Use proper line spacing for better readability..</p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Maintain a high contrast ratio between text and
                    background.
                  </p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <h3>Step 6: Test Your Website on Multiple Devices</h3>
              <div
                className={
                  Styles.MobileResponsivenessSection2AnswerImagesContainer
                }
              >
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>
                    👉🏻 Use tools like Google Mobile-Friendly Test or
                    BrowserStack.
                  </p>

                  <p>
                    👉🏻 Check responsiveness on different screen sizes and
                    resolutions.
                  </p>
                  {/* <img src={SolutionImages[3]} alt="loding step 2" /> */}
                </div>
                <div
                  className={
                    Styles.MobileResponsivenessSection2AnswerImgContainer
                  }
                >
                  <p>👉🏻 Fix any layout shifts or overlapping elements.</p>
                  {/* <img src={SolutionImages[4]} alt="loding step 3" /> */}
                </div>
              </div>
              <p>
                I hope you found this helpful! 👍✨ Don't forget to rate this
                blog!
              </p>
              <h3>HashTags</h3>
              <p>
                #MobileFriendly #ResponsiveDesign #WebOptimization #UXDesign
                #FastLoading #SEO #TouchNavigation #TechTips #WebsiteSpeed
                #UserExperience
              </p>
              <h3>Keywords</h3>
              <p>
                mobile responsiveness, responsive website design, optimize for
                mobile, improve site speed, touch-friendly navigation, mobile
                SEO, best mobile-friendly themes, website optimization tips, how
                to make a website mobile-friendly, fast-loading websites.
              </p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default MobileResponsiveness;
